import React from "react";
import { AiOutlineClose } from "react-icons/ai";
import { CloseContainer } from "../../../../common/styled/project";

const CloseButton = ({ changeModalState }) => {
  return (
    <CloseContainer onClick={() => changeModalState("")}>
      <AiOutlineClose />
    </CloseContainer>
  );
};

export default CloseButton;
